// extracted by mini-css-extract-plugin
module.exports = {"resizeBox":"styleResizeBox_resizeBox__zpwVz"};